import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";
import { useI18n } from '@/hooks/useI18n';

interface ShareLinkStep2ConfigureProps {
  linkPassword: string;
  setLinkPassword: (val: string) => void;
  linkExpiry: string | null;
  setLinkExpiry: (val: string | null) => void;
}

export const ShareLinkStep2Configure = ({
  linkPassword,
  setLinkPassword,
  linkExpiry,
  setLinkExpiry,
}: ShareLinkStep2ConfigureProps) => {
  const { t } = useI18n();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {t('itinerary.configureLinkSettings')}
        </h3>
        <p className="text-sm text-gray-600">
          {t('itinerary.configureLinkSettingsDescription')}
        </p>
      </div>

      <Alert className="bg-blue-50 border-blue-200">
        <Info className="h-4 w-4 text-blue-600" />
        <AlertDescription className="text-sm text-blue-800">
          {t('itinerary.linkSecurityInfo')}
        </AlertDescription>
      </Alert>

      <div className="space-y-4">
        <div>
          <Label htmlFor="link-password" className="text-sm font-medium text-gray-700">
            {t('itinerary.password')}
            <span className="text-red-500 ml-1">*</span>
          </Label>
          <Input
            id="link-password"
            type="password"
            value={linkPassword}
            onChange={(e) => setLinkPassword(e.target.value)}
            placeholder="••••••••"
            className="mt-1.5"
            required
          />
          <p className="text-xs text-gray-500 mt-1">
            {t('itinerary.passwordHint')}
          </p>
        </div>

        <div>
          <Label htmlFor="link-expiry" className="text-sm font-medium text-gray-700">
            {t('itinerary.expiry')}
          </Label>
          <Select
            value={linkExpiry || "30"}
            onValueChange={(v) => setLinkExpiry(v)}
          >
            <SelectTrigger id="link-expiry" className="mt-1.5">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="1">1 {t('itinerary.day')}</SelectItem>
              <SelectItem value="2">2 {t('itinerary.days')}</SelectItem>
              <SelectItem value="7">7 {t('itinerary.days')}</SelectItem>
              <SelectItem value="10">10 {t('itinerary.days')}</SelectItem>
              <SelectItem value="30">30 {t('itinerary.days')}</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-xs text-gray-500 mt-1">
            {t('itinerary.expiryHint')}
          </p>
        </div>
      </div>
    </div>
  );
};
